<template>
  <div>
    <h1>{{title}}
 <v-btn icon color="black" class="fbbtn" x-large  @click="share">
   <v-icon>mdi-share-variant</v-icon>

      </v-btn>

    </h1>
    <p v-html="description">  </p>

     


      
    <v-dialog 
          v-model="share_dialog"
          transition="scale-transition" 
          @click="hide"

      width="250"
      content-class="share"><br>
Partagez le mur sur :<br>
     
<v-btn icon color="black" class="fbbtn" large>
    <ShareNetwork
      network="facebook"
      :url="social_url"
      :title="socials_title"
      :description="socials_description"
      :quote="socials_description"
      :hashtags="socials_hashtags"
    ><svg style="width:24px;height:24px" viewBox="0 0 24 24">
      <path fill="currentColor" d="M12 2.04C6.5 2.04 2 6.53 2 12.06C2 17.06 5.66 21.21 10.44 21.96V14.96H7.9V12.06H10.44V9.85C10.44 7.34 11.93 5.96 14.22 5.96C15.31 5.96 16.45 6.15 16.45 6.15V8.62H15.19C13.95 8.62 13.56 9.39 13.56 10.18V12.06H16.34L15.89 14.96H13.56V21.96A10 10 0 0 0 22 12.06C22 6.53 17.5 2.04 12 2.04Z" />
    </svg>
  </ShareNetwork>
</v-btn>

<v-btn icon color="black" class="twbtn" >
    <ShareNetwork
    network="twitter"
    :url="social_url"
    :title="socials_title"
    :description="socials_description"
    :quote="socials_description"
    :hashtags="socials_hashtags"
      ><svg style="width:24px;height:24px" viewBox="0 0 24 24">
        <path fill="currentColor" d="M22.46,6C21.69,6.35 20.86,6.58 20,6.69C20.88,6.16 21.56,5.32 21.88,4.31C21.05,4.81 20.13,5.16 19.16,5.36C18.37,4.5 17.26,4 16,4C13.65,4 11.73,5.92 11.73,8.29C11.73,8.63 11.77,8.96 11.84,9.27C8.28,9.09 5.11,7.38 3,4.79C2.63,5.42 2.42,6.16 2.42,6.94C2.42,8.43 3.17,9.75 4.33,10.5C3.62,10.5 2.96,10.3 2.38,10C2.38,10 2.38,10 2.38,10.03C2.38,12.11 3.86,13.85 5.82,14.24C5.46,14.34 5.08,14.39 4.69,14.39C4.42,14.39 4.15,14.36 3.89,14.31C4.43,16 6,17.26 7.89,17.29C6.43,18.45 4.58,19.13 2.56,19.13C2.22,19.13 1.88,19.11 1.54,19.07C3.44,20.29 5.7,21 8.12,21C16,21 20.33,14.46 20.33,8.79C20.33,8.6 20.33,8.42 20.32,8.23C21.16,7.63 21.88,6.87 22.46,6Z" />
    </svg>
    </ShareNetwork>
</v-btn><br><br>
    </v-dialog>

    <div id="camera" v-if="user">
      <v-btn class="mx-2 button" fab dark large color="black">
        <v-icon dark>
          mdi-camera
        </v-icon>
      </v-btn>
      <div id="camera-input">
        <input id="photo" type="file" accept="image/*" @change="uploadImage($event)" capture="camera" />
      </div>
    </div>


    <v-dialog 
          v-model="dialog" 
          fullscreen 
          hide-overlay 
          transition="scale-transition" 
          @click="hide"
          @keydown="keydownevent"
      content-class="preview">
      <v-btn icon color="black" class="closebtn" x-large @click="hide">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <img :src="item_image" 
          @click="hide"/>
        <v-btn icon color="black" class="sharebtn" x-large  @click="share">
        <v-icon>mdi-share-variant</v-icon>
      </v-btn>

      <v-btn icon color="black" class="leftbtn" x-large @click="previous">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-btn icon color="black" class="rightbtn" x-large @click="next">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-dialog>


    <div id="camera" v-if="user">
      <v-btn class="mx-2 button" fab dark large color="black">
        <v-icon dark>
          mdi-camera
        </v-icon>
      </v-btn>
      <div id="camera-input">
        <input id="photo" type="file" accept="image/*" @change="uploadImage($event)" capture="camera" />
      </div>
    </div>    

    <vue-masonry-wall ref="wall" :items="items" :options="options" @append="append">
      <template v-slot:default="{item}">
        <div class="item" @click="show(item)">
          <img :src="item.thumbnail" />

          <h5 v-if="!item.validated">En attente de validation</h5>
          <h5 v-if="item.title">{{item.title}}</h5>
        </div>
      </template>
    </vue-masonry-wall>
  </div>
</template>

<script>
  import VueMasonryWall from 'vue-masonry-wall'
  import axios from 'axios'
  // import vueTitle from './Meta';
  var keydelay = false
  export default {
    components: {
      VueMasonryWall,
      // vueTitle,
    },
    props: {
      msg: String
    },
    data() {
      return {
        items: [],
        loaded_items: [],
        item_image: '',
        api_url: '',
        title:'',
        user:'',
        social_url:'',
        socials_title:'',
        socials_description:'',
        socials_hashtags:'',
        description:'',
        dialog: false,
        share_dialog: false,
        options: {
          width: 200,
        }
      }
    },
    mounted() {
      this.loadConfig()
    },

    methods: {
      keydownevent(event){
        console.log(keydelay)
        if (!keydelay){
            if (this.dialog){

            keydelay = true
              switch (event.keyCode) {
                  case 37:
                      this.previous()
                      break;
                  case 39:
                    this.next()
              }
            }
            setTimeout(function(){
            keydelay = false
            }, 100);
        }else{
          keydelay = true
        }

      },
      loadConfig(){
        const node = document.querySelector(`meta[property='wall_url']`);
        if (node !== null) {
          this.api_url = node.getAttribute('content');
        }
        if (document.querySelector(`meta[property='og:url']`)){
          this.social_url = document.querySelector(`meta[property='og:url']`).getAttribute('content');
        }
        if (document.querySelector(`meta[property='og:title']`)){
          this.socials_title = document.querySelector(`meta[property='og:title']`).getAttribute('content');
        }
        if (document.querySelector(`meta[property='wall_hashtags']`)){
          this.socials_hashtags = document.querySelector(`meta[property='wall_hashtags']`).getAttribute('content');
        }
        if (document.querySelector(`meta[property='og:description']`)){
          this.socials_description = document.querySelector(`meta[property='og:description']`).getAttribute('content');
        }
        axios
        .get( this.api_url+'config')
        .then(response => {
           this.title = response.data.wall.title
           this.description = response.data.wall.description
           this.user = response.data.user
           axios
          .get( this.api_url+'data')
          .then(response => {
            let medias = response.data.medias
            for( let i=0; i < medias.length; i++){
              this.items.push(medias[i])
            }
            this.$refs.wall.redraw()
            this.setDefaultImage()
          })
        })
      },
      setDefaultImage(current_item){        
        if (document.querySelector(`meta[property='og:image']`)){
          if (current_item){
            document.querySelector(`meta[property='og:image']`).setAttribute('content', current_item);
          }else{
            document.querySelector(`meta[property='og:image']`).setAttribute('content', this.items[0]['image']);
          }
        }
      },
      uploadImage(event) {
        let data = new FormData();
        data.append('file', event.target.files[0]);
        let config = {
          headers : {
            'Content-Type' : 'image/png',
            'X-CSRFToken' : this.getCookie('csrftoken')
          }
        }
        axios.put(
          this.api_url+'upload', 
          data,
          config
        ).then(
          response => {
            console.log('image upload response > ', response)
            this.add(response.data.media)
          }
        )
      },
      getCookie(name) {
        let cookieValue = null;
        if (document.cookie && document.cookie !== '') {
            const cookies = document.cookie.split(';');
            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i].trim();
                // Does this cookie string begin with the name we want?
                if (cookie.substring(0, name.length + 1) === (name + '=')) {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue
      },
      append() {
        // for (let i = 0; i < 20; i++) {
        //   this.items.push({title: `Item ${this.items.length}`, content: 'Content'})
        // }
      },
      add(media) {
        this.items.unshift(media)
        // this.options.width = 450;
        this.$refs.wall.redraw()

      },
      show(item) {
        this.dialog = true
        this.item_image = item.image
        this.setDefaultImage(item.image)
      },
      hide() {
        this.dialog = false
        this.item_image = ''
        this.setDefaultImage()
      },
      share(){
        this.share_dialog = true
      },
      previous() {
        if (this.item_image){

          var position = 0
          for (let i = 0; i < this.items.length; i++) {
            if (this.items[i].image == this.item_image){
              position = i
              break
            }
          }
          if (position == 0){
            this.item_image = this.items[this.items.length-1].image
            this.setDefaultImage(this.item_image)
          }else{
            this.item_image = this.items[position-1].image
            this.setDefaultImage(this.item_image)
          }
        }
      },
      next() {
        if (this.item_image){
          var position = 0
          for (let i = 0; i < this.items.length; i++) {
            if (this.items[i].image == this.item_image){
              position = i
              break
            }
          }
          if (position == (this.items.length-1)){
            this.item_image = this.items[0].image
            this.setDefaultImage(this.item_image)
          }else{
            this.item_image = this.items[position+1].image
            this.setDefaultImage(this.item_image)
          }
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  #camera {
    position: fixed;
    bottom: 30px;
    right: 30px;
    z-index: 100;
  }

  #camera-input {
    position: fixed;
    bottom: 30px;
    right: 30px;
    z-index: 101;
  }

  #photo {
    width: 70px;
    height: 70px;
    opacity: 0;
  }

  .masonry-item {
    margin: 12px;
    background: #789;
  }

  .item {
    overflow: hidden;
    position: relative;
    width: 100%;
    background: #F5F5F5;
  }

  .item h5 {
    position: absolute;
    top: 0;
    width: 100%;
    color: #FFF;
    text-align: center;
    background-color: rgba(174, 116, 40, 0.95);

  }

  .item img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    line-height: 0;
    display: block;
    border-radius: 8px;
  }

  .preview {
    overflow: hidden;
    position: relative;
    background-color: #222;
  }

  .preview img {
    object-fit: contain;
    width: 100%;
    height: 100%;
    line-height: 0;
    display: block;
  }
.share{
    background-color: #FFF;
    position: relative;
    text-align: center;

}
  .theme--light.v-btn.v-btn--icon.closebtn {
    position: fixed;
    top: 10px;
    right: 10px;
    background-color: #FFF;
    border: 1px solid #DDD;
  }
  .theme--light.v-btn.v-btn--icon.sharebtn {
    position: fixed;
    bottom: 10px;
    right: 10px;
    background-color: #FFF;
    border: 1px solid #DDD;
  }
  .theme--light.v-btn.v-btn--icon.rightbtn {
    position: fixed;
    bottom: 50%;
    right: 10px;
    background-color: #FFF;
    border: 1px solid #DDD;
  }
  .theme--light.v-btn.v-btn--icon.leftbtn {
    position: fixed;
    bottom: 50%;
    left: 10px;
    background-color: #FFF;
    border: 1px solid #DDD;
  }
</style>